import type { AppEvent } from '../core/types.js';

export interface DailyBucket {
  localDate: string;
  uses: number;
  successes: number;
  rescues: number;
  urges: number;
}

export function buildDailyBuckets(events: AppEvent[], days = 7, today: Date = new Date()): DailyBucket[] {
  const buckets: DailyBucket[] = [];
  const map = new Map<string, DailyBucket>();
  for (let i = days - 1; i >= 0; i--) {
    const d = new Date(today); d.setDate(d.getDate() - i);
    const key = formatLocalDate(d);
    const b: DailyBucket = { localDate: key, uses: 0, successes: 0, rescues: 0, urges: 0 };
    buckets.push(b); map.set(key, b);
  }
  for (const e of events) {
    if (e.status === 'undone') continue;
    const b = map.get(e.localDate);
    if (!b) continue;
    if (e.type === 'usage_logged') b.uses++;
    else if (e.type === 'success_logged') b.successes++;
    else if (e.type === 'rescue_completed' || e.type === 'rescue_started') b.rescues++;
    else if (e.type === 'urge_logged' || e.type === 'urge_episode_started') b.urges++;
  }
  return buckets;
}

export function buildTriggerMap(triggers: string[] | undefined): Array<{ tag: string; count: number }> {
  if (!triggers || triggers.length === 0) return [];
  const counts = new Map<string, number>();
  for (const t of triggers) counts.set(t, (counts.get(t) ?? 0) + 1);
  return [...counts.entries()].map(([tag, count]) => ({ tag, count })).sort((a, b) => b.count - a.count);
}

function formatLocalDate(d: Date): string {
  const y = d.getFullYear(), m = String(d.getMonth() + 1).padStart(2, '0'), day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}
